import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

const GiftTestimonial: React.FC = () => {
  return (
    <Card sx={{
      border: '1px solid rgb(200, 230, 201)',
      bgcolor: 'rgba(232, 245, 233, 0.5)',
      borderRadius: '12px',
      mt: 2,
    }}>
      <CardContent sx={{ p: 3, textAlign: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <img src="/logo.png" alt="LGCY Logo" style={{ width: 50, height: 25 }} />
        </Box>
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'rgb(46, 125, 50)', 
            fontStyle: 'italic', 
            mb: 1, 
          }}
        >
          "Seeing Charlie's tribute appear in my inbox brought me to tears of joy."
        </Typography>
        <Typography 
          variant="caption" 
          sx={{ 
            color: 'rgb(56, 142, 60)', 
            fontWeight: 500, 
          }}
        >
          — Mia, Portland
        </Typography>
      </CardContent>
    </Card>
  );
};

export default GiftTestimonial;